// src/app/contractor-grid/contractor-grid.component.ts
import { Component, Inject, OnInit } from '@angular/core';
import { Contractor } from '../../objects/Contractor';
import { ContractorService } from '../../Services/contractor.service';

import { ActivatedRoute, Router } from '@angular/router';
import { Project, ProjectContractor } from 'src/app/objects/Project';
import { ProjectContractorService } from 'src/app/Services/projectcontractor.service';
import { GlobalService } from 'src/app/global-service.service';
import { ProjectService } from 'src/app/Services/project.services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectMaterialAddComponent } from '../project-material-add/project-material-add.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-project-contractors-add',
  templateUrl: './project-contractors-add.component.html',
  styleUrls: ['./project-contractors-add.component.css']
})
 
export class ProjectContractorsAddComponent implements OnInit {
  project: Project |any;
  isLoadingResults: boolean;

  
  constructor( private route: ActivatedRoute,  private router: Router,
    private contractorService: ContractorService,
    private projectContractorService: ProjectContractorService,
    private projectService: ProjectService,private globalService: GlobalService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ProjectContractorsAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
    ) { } 










  contractors: Contractor[] = [];
  searchTerm = '';
  loading = true;
  addingName: string | null = null;

  isMobile?: boolean;
  NotMobile?: boolean;
   

  ngOnInit(): void {
 
    this.globalService.isMobile$.subscribe((value) => {
      this.isMobile = value;
    });

    if (this.data != undefined) {
      
      this.loadProject(this.data.projectId);
    }
    this.loadContractors();
  }
 
  loadContractors() {
    this.contractorService.getContractors().subscribe({
      next: (contractors) => {
        this.contractors = contractors;
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }
  loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project;
     
        
    });
 
  }

  get filteredContractors(): Contractor[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) { return this.contractors; }
    return this.contractors.filter(c =>
      [c.name, c.jobTitle, c.cellPhone, c.email].some(v => (v ?? '').toString().toLowerCase().includes(term)));
  }

  // ProjectContractor rows are copies with no link back to the Contractor, so match on name + phone.
  isOnProject(contractor: Contractor): boolean {
    const onProject: ProjectContractor[] = this.project?.contractors ?? [];
    return onProject.some(pc => pc.name === contractor.name && (pc.cellPhone ?? '') === (contractor.cellPhone ?? ''));
  }

  initials(name: string): string {
    return (name ?? '').split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');
  }

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
      this.NotMobile = false;
    }
      else
    {this.isMobile = false;
    
      this.NotMobile = true;}
    
    
  }
  

  addContractorToProjectContractors(contractor:Contractor)
  {
    


    let newProjectContractor: ProjectContractor = {
      id: 0,
      name: contractor.name,
    age: contractor.age,
    jobTitle: contractor.jobTitle,
    cellPhone: contractor.cellPhone,
    email: contractor.email,
    salary: contractor.salary,
    hourlyWage: contractor.hourlyWage,
      cost:0.00,imageContent:contractor.imageContent
    };
 
     
    if (!this.project || this.isOnProject(contractor)) { return; }
    this.addingName = contractor.name;

    let newProject: Project = { ...this.project, contractors: [...(this.project.contractors ?? []), newProjectContractor] };
  
    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        // Simple message.
        this.openSnackBar(contractor.name);
        this.isLoadingResults = false;
        this.addingName = null;
        console.log('Project edited successfully!');
        this.loadProject(this.project?.id);
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
        this.addingName = null;
        this.snackBar.open('Could not add contractor. Please try again.', 'Close', { duration: 4000 });
      });
  }

  openSnackBar(name: string) {
    this.snackBar.open(`${name} added to project`, undefined, { duration: 2500 });
  }
}
 